import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{yield\n  (hash\n    sortBy=@sortBy\n    sortDirection=@sortDirection\n    updateSort=this.updateSort\n    externalSort=true\n  )\n}}")